import React, {Fragment, useState, useEffect} from 'react'
import {Accordion, TextArea, Form, Icon} from 'semantic-ui-react'
import * as moment from 'moment'
import * as StoriesActions from '../../../actions/StoriesActions'
import {useDispatch, useSelector} from 'react-redux';

export const Teaser = (props) => {
    const [active, setActive] = useState(false);

    const dispatch = useDispatch();
    const settings = {
        teaser_text: '',
        ...useSelector(({stories}) => stories.selected.settings)
    }

    return (
        <Fragment>
            <Accordion.Title active={active} onClick={(e) => {
                    setActive(!active);
                }}><Icon name='dropdown' /> Teaser</Accordion.Title>
            <Accordion.Content active={active}>
                <Form>
                    <label style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>
                        <div style={{flexGrow: 1}}>Text</div>
                        {
                            (settings.teaser_text.length > 0)?
                                <span style={{
                                    fontWeight: 'normal'
                                }}>({settings.teaser_text.length} Zeichen)</span>
                            :null
                        }
                    </label>
                    <Form.Field>
                        <TextArea disabled={props.readonly?true:null} value={settings.teaser_text} placeholder='Bitte geben Sie einen Teasertext ein...' onChange={(e) => {
                            dispatch(StoriesActions.update_settings('teaser_text', e.target.value));
                        }} />
                    </Form.Field>
                </Form>
            </Accordion.Content>
        </Fragment>
    )
}